<template>
  <div>
    <h1 class="page-title text-left">Arboviral Details</h1>
    <div class="panel">
      <div class="panel-heading">
        <h3 class="panel-title">
          Details
          <router-link :to="{ name: 'data-arboviral' }" class="pull-right ml-10"><i class="fa fa-list"></i></router-link>
          <i class="fa fa-pencil pointer pull-right" v-on:click="form.showEdit({id: id, list: true})"></i>
        </h3>
      </div>
      <div class="panel-body">
        <dl class="dl-horizontal">

          <dt>Sample No.</dt>
          <dd>{{ form.data.sampleNumber }}</dd>

          <dt>Date Tested</dt>
          <dd>{{ form.data.dateTested }}</dd>

          <dt>Performed By</dt>
          <dd>{{ form.data.performedBy }}</dd>

          <dt>Pool No.</dt>
          <dd>{{ form.data.poolNumber }}</dd>

          <dt>Pool Size</dt>
          <dd>{{ form.data.poolSize }}</dd>

          <dt>Assay Type</dt>
          <dd>{{ assayName(form.data.assayId) }}</dd>

          <dt>Result</dt>
          <dd>{{ resultName(form.data.resultId) }}</dd>


        </dl>
      </div>
    </div>

    <site-form :form="form"></site-form>


  </div>
</template>

<script>
  import ArboviralService from '@/services/ArboviralService';
  import Form from '@/utils/form';
  import loader from '@/utils/loader';
  import siteForm from '@/components/forms/arboviral';

  import store from '@/store';

  export default {
    name: 'arboviral_details',

    components: {
      siteForm
    },

    props: ['id'],

    data() {
      return {
        form: new Form(
          ArboviralService,
          {
          })
      }
    },

    methods: {
      assayName(id) {
        return this.$store.getters.assaysNameById(id);
      },
      resultName(id) {
        return this.$store.getters.resultsNameById(id);
      },
    },

    mounted() {

      loader.lookups()
        .then(() => {
          this.form.getDetails(this.id);
        });
    }

  }
</script>

<style lang="scss">

</style>
